<template>
  <div>
    <div class="row-block">
      <div class="input-group">
        <input
          ref="input"
          v-validate="'url|verify_url'"
          type="text"
          name="videoLinkField"
          :value="videoLinkCopy"
          :placeholder="placeholder"
          :class="{
            error: errors.has('videoLinkField'),
            valid: fields.videoLinkField ? fields.videoLinkField.valid : null
          }"
          @input="videoLinkChange"
        />

        <div v-if="videoLinkCopy" class="video-remove" @click="remove">
          <icon-close />
        </div>
      </div>
    </div>

    <label class="helper" v-show="errors.has('videoLinkField')">
      {{ errors.first('videoLinkField') }}
    </label>

    <div v-show="!errors.has('videoLinkField') && videoLinkCopy" class="video-container">
      <div v-if="preview_img" class="image-preview" @click="$emit('show_modal')">
        <img :src="preview_img" />
        <div class="duration-block">{{ duration | mm_ss }}</div>
      </div>

      <div class="input-block">
        <input
          v-model="tempTitle"
          :readonly="isReadOnly"
          type="text"
          class="form-control vcv-input"
          :placeholder="$tr('vacancy.videointerview.video.title')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Validator from 'validator';
const isYoutube = urlString => urlString.indexOf('youtube') !== -1 || urlString.indexOf('youtu.be') !== -1
const acceptHostnames = ['youtube.com', 'www.youtube.com', 'youtu.be', 'www.youtu.be'];

const dictionary = {
  en: {
    messages: { verify_url: n => 'Field ' + n + ' must be a valid YouTube link.' },
    attributes: { videoLinkField: 'video link' }
  },
  ru: {
    messages: { verify_url: n => 'Поле ' + n + ' должно быть валидным url-адресом на видео YouTube.' },
    attributes: { videoLinkField: 'ссылка на видео' }
  },
  ja: {
    messages: { verify_url: n => 'このフィールドは、YouTube動画の有効なURLアドレスである必要があります。' },
    attributes: { videoLinkField: 'ビデオリンク' }
  }
};

export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },

    value: {
      type: String,
      default: ''
    },

    title: {
      type: String,
      default: ''
    },

    isReadOnly: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      videoLinkCopy: '',
      editableVideoLink: '',
      editMode: false,
      duration: 0,
      youtube_id: null,
      tempTitleInner: null
    };
  },

  computed: {
    errorsSave() {
      const fields = Object.keys(this.fields).map(e => this.fields[e]);

      return fields.every(el => el.valid);
    },

    has_error() {
      const fields = Object.keys(this.fields).map(e => this.fields[e]);

      return fields.every(el => !el.valid);
    },

    preview_img() {
      if (!this.youtube_id) {
        return '';
      }

      return `https://img.youtube.com/vi/${this.youtube_id}/0.jpg`;
    },

    tempTitle: {
      get() {
        if (this.tempTitleInner !== null) {
          return this.tempTitleInner;
        }
        return this.title;
      },

      set(val) {
        this.tempTitleInner = val;
        this.$emit('set_title', val);
      }
    }
  },

  watch: {
    errorsSave(val) {
      this.$emit('errSave', val);
    },

    has_error(val) {
      this.$emit('has_error', val);
    },

    title(val) {
      this.$emit('set_title', val);
    },

    youtube_id(val) {
      if (val) {
        window
          .fetch(
            `https://www.googleapis.com/youtube/v3/videos?id=${val}&part=contentDetails&key=AIzaSyCWzLActlnZdGiaVDZBtamiit1k_uLdNFE`
          )
          .then(response => {
            return response.json();
          })
          .then(data => {
            if (data && data.items && data.items[0] && data.items[0].contentDetails) {
              this.duration = this.convert_time(data.items[0].contentDetails.duration);
              this.$emit('change_duration', this.duration);
            }
          });

        window
          .fetch(
            `https://www.googleapis.com/youtube/v3/videos?id=${val}&part=snippet&key=AIzaSyCWzLActlnZdGiaVDZBtamiit1k_uLdNFE`
          )
          .then(response => {
            return response.json();
          })
          .then(data => {
            if (data && data.items && data.items[0] && data.items[0].snippet && !this.title) {
              this.$emit('set_title', data.items[0].snippet.title);
            }
          });
      }
    }
  },

  created() {
    this.$validator.extend('verify_url', {
      getMessage: field => 'Field' + field + ' must be a valid YouTube link.',
      validate: value => this.validUrl(value)
    });

    this.$validator.localize(dictionary);
  },

  mounted() {
    if (this.value) {
      this.videoLinkCopy = this.value;
      this.videoLinkChange(this.value);
    }
  },

  destroyed() {
    this.$parent.$off('saveOnParent');
  },

  methods: {
    convert_time(duration) {
      if (!duration) {
        return 0;
      }
      var a = duration.match(/\d+/g);

      if (duration.indexOf('M') >= 0 && duration.indexOf('H') == -1 && duration.indexOf('S') == -1) {
        a = [0, a[0], 0];
      }

      if (duration.indexOf('H') >= 0 && duration.indexOf('M') == -1) {
        a = [a[0], 0, a[1]];
      }
      if (duration.indexOf('H') >= 0 && duration.indexOf('M') == -1 && duration.indexOf('S') == -1) {
        a = [a[0], 0, 0];
      }

      duration = 0;

      if (a.length == 3) {
        duration = duration + parseInt(a[0]) * 3600;
        duration = duration + parseInt(a[1]) * 60;
        duration = duration + parseInt(a[2]);
      }

      if (a.length == 2) {
        duration = duration + parseInt(a[0]) * 60;
        duration = duration + parseInt(a[1]);
      }

      if (a.length == 1) {
        duration = duration + parseInt(a[0]);
      }

      return duration;
    },

    validUrl(urlString) {
      if (!Validator.isURL(urlString)) {
        return false;
      }

      let urlElem = document.createElement('a');
      urlElem.href = urlString;

      return acceptHostnames.includes(urlElem.hostname);
    },

    parseYoutube(urlElem) {
      const isYoutubeWatchLink = urlElem =>
        urlElem.pathname.indexOf('watch') !== -1 && urlElem.search.indexOf('v') !== -1;
      const lastPathname = urlElem => urlElem.pathname.split('/').pop();

      // Case: https://www.youtube.com/watch?v=86zlYfBvkiM
      if (isYoutubeWatchLink(urlElem)) {
        // Cut "?" and separate by "&"
        const params = urlElem.search.slice(1).split('&')
        const v = params.find(p => p[0] === 'v')

        // Cut "v="
        const id = v.slice(2)
        this.youtube_id = id;

        return id
          ? `https://www.youtube.com/embed/${id}?rel=0&amp;showinfo=0&amp;playsinline=1&modestbranding=1&showinfo=0&fs=0`
          : null;
      } else {
        const id = lastPathname(urlElem);
        this.youtube_id = id;

        return id
          ? `https://www.youtube.com/embed/${id}?rel=0&amp;showinfo=0&amp;playsinline=1&modestbranding=1&showinfo=0&fs=0`
          : null;
      }
    },

    parseUrl(urlString) {
      // test ref for iframe
      const regexp = /src="([^"]*)"/g;
      const res = regexp.exec(urlString);

      if (res && res.length) {
        urlString = res.pop();
      }

      if (!this.validUrl(urlString)) {
        return null;
      }

      let urlElem = document.createElement('a');
      urlElem.href = urlString;

      if (isYoutube(urlString)) {
        return this.parseYoutube(urlElem);
      }
    },

    toggleEditMode() {
      this.editMode = !this.editMode;

      if (this.editMode) {
        setTimeout(() => {
          this.$refs.input.focus();
        }, 100);
      }
    },

    videoLinkChange(e) {
      const val = e && e.target ? e.target.value : e;
      const iframe = this.parseUrl(val);

      // Assign empty string to case
      // when copy-paste same value
      // and visible value not changed
      this.videoLinkCopy = '';

      if (iframe) {
        this.videoLinkCopy = iframe;
        this.$emit('setVideoLink', this.videoLinkCopy);

        this.$nextTick(() => {
          this.$validator.validateAll();
        });
      } else {
        this.videoLinkCopy = val;
        this.$emit('setVideoLink', this.videoLinkCopy);
      }
      this.$emit('setChange', true);
    },

    remove() {
      this.videoLinkCopy = '';
      this.$emit('setVideoLink', this.videoLinkCopy);
      this.$emit('set_title', '');
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  font-size: 16px;
  display: block;
  margin-bottom: 10px;
}

.row-block {
  display: flex;
}

input {
  height: 40px;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  border: 1px solid #d2d6e0;
  transition: border 0.3s;

  &:focus {
    border: 1px solid $green;
    transition: border 0.3s;
  }
}

button {
  border: none;
  &:hover {
    cursor: pointer;
  }
}

.input-group {
  display: flex;
  position: relative;
  width: 100%;

  input {
    padding-right: 40px;
    border: 1px solid #d2d6e0;
    transition: border 0.3s;

    &:focus {
      border: 1px solid $green;
      transition: border 0.3s;
    }
  }

  .video-remove {
    position: absolute;
    width: 15px;
    right: 18px;
    top: 12px;
    cursor: pointer;
  }

  .accept {
    height: 40px;
    width: 40px;
    min-width: 40px;
    background-color: $green;
    background-image: url('/static/images/elements/trigger_on.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 15px;
    border-radius: 0 5px 5px 0;

    &:disabled {
      background-color: $btn-red;
    }
  }
}

.cancel {
  margin-left: 10px;
  color: $green;
  font-weight: 500;
  font-size: 16px;
  background: transparent;
}

label.helper {
  display: block;
  margin: 0;
  color: #a6a6a6;
  line-height: 20px;
  font-size: 14px;
  color: $error-color;
  padding-top: 5px;
}

.video-container {
  position: relative;
  margin-top: 10px;
  display: flex;
  align-items: center;
  margin-top: 20px;
  cursor: pointer;

  .image-preview {
    position: relative;
    width: 84px;
    height: auto;
    margin-right: 14px;
    position: relative;
    overflow: hidden;

    img {
      max-width: 100%;
      max-height: 100%;
      height: auto;
      width: 100%;
      border-radius: 4px;
    }
  }

  .video-title {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.005em;
  }
}

.duration-block {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px;
  background: #233346;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.005em;
  color: #fff;
}

.input-block {
  flex: 1;
}
</style>
